import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-custom-item-dialog',
  templateUrl: './custom-item-dialog.component.html',
  styleUrls: ['./custom-item-dialog.component.scss'],
})
export class CustomItemDialogComponent {
  itemName = '';
  itemPrice: number = null;

  constructor(private dialogRef: MatDialogRef<CustomItemDialogComponent>) {}

  submit(): void {
    // Negative prices are allowed (cashier uses them as a free-form
    // discount line — Clover atomic order supports negative-priced
    // line items). Empty / zero / non-finite still blocks because
    // those carry no intent.
    if (this.itemPrice == null || this.itemPrice === 0 || !isFinite(this.itemPrice)) { return; }
    const trimmed = (this.itemName || '').trim();
    this.dialogRef.close({
      name: trimmed || 'Custom Item',
      price: Math.round(this.itemPrice * 100),
    });
  }

  /** Template guard for the Add to Cart button. Mirrors submit(). */
  isPriceInvalid(): boolean {
    return this.itemPrice == null || this.itemPrice === 0 || !isFinite(this.itemPrice);
  }

  close(): void {
    this.dialogRef.close();
  }
}
